import { AgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";
import { ContactCredit } from "./ContactCreditData"

export const ContactCreditsGetAllCreditsQuery: AgTechQuery<any, ContactCredit[]> = {
    queryKey: () => ['ContactCreditsAll'],
    query: async (props) => {
        return await props.http.getEntity<ContactCredit[]>({
            request: 'ContactCredit'
        });
    },
    content: {
        loadingText: 'Loading credits...',
        failureText: 'Failed to load credits.'
    }
}

export const ContactCreditsGetContactCreditsQuery: AgTechQuery<number, ContactCredit[]> = {
    queryKey: (contactId: number) => ['ContactCreditsContact', contactId],
    query: async (props) => {
        return await props.http.getEntity<ContactCredit[]>({
            request: `Contact/${props.inputData}/Credits`
        });
    },
    content: {
        loadingText: 'Loading contact credits...',
        failureText: 'Failed to load contact credits.'
    }
}